// TODO: build from source, not through online bundler...
import '../../../vendor/ckeditor/build/ckeditor';
import '../../../vendor/ckeditor/build/translations/de';
import '../../../vendor/ckeditor/build/translations/it';

export default window.ClassicEditor;
